module.exports = global["moment"] = require("-!.\\moment.js");


//////////////////
// WEBPACK FOOTER
// ./~/moment/moment.js-exposed
// module id = 54
// module chunks = 0 3 6